import i18next from 'i18next'
import * as React from 'react'
import { incompanyBlockClasses } from '../../../utils/style'
import { getClassName } from '../../../utils/utils'
import { Link } from 'widgets-for-react'
import { useInView } from '../../../utils/hooks/hooks/useInView'

export type IncompanyBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  introClassName: string
  contentClassName: string
  textClassName: string
  footerClassName: string
  clickableWrapperClassName: string
  clickablePrimaryClassName: string
  clickableLabelClassName: string
}>

export function IncompanyBlockLayout() {
  const classes = incompanyBlockClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("IncompanyBlockLayout inView:", inview),
    true
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')
  return (
    <section key={`block-incompany`} id={`io-incompany`} ref={ref} className={inviewClassName}>
      <div className={getClassName(incompanyBlockClasses, 'innerClassName', '')}>
        <header className={getClassName(incompanyBlockClasses, 'headerClassName', '')}>
          <h2 className={getClassName(incompanyBlockClasses, 'titleClassName', '')}>
            {i18next.t('incompany:title')}
          </h2>
        </header>

        <div className={getClassName(incompanyBlockClasses, 'introClassName', '')}>
          <div>
            <p>{i18next.t('incompany:intro')}</p>
          </div>
        </div>

        <div className={getClassName(incompanyBlockClasses, 'contentClassName', '')}>
          <div className={getClassName(incompanyBlockClasses, 'textClassName', '')}>
            <p>{i18next.t('incompany:text')}</p>
          </div>
        </div>

        <footer className={getClassName(incompanyBlockClasses, 'footerClassName', '')}>
          <div className={getClassName(incompanyBlockClasses, 'clickableWrapperClassName', '')}>
            <Link
              to="/opleidingen/incompany-en-maatwerktrainingen"
              className={getClassName(incompanyBlockClasses, 'clickablePrimaryClassName', '')}
            >
              <span className={getClassName(incompanyBlockClasses, 'clickableLabelClassName', '')}>
                {i18next.t('incompany:readMore')}
              </span>
            </Link>
          </div>
        </footer>
      </div>
    </section>
  )
}
